// import React from 'react';
// import './Contact.css';
// import Navbar from '../Navbar/Navbar';
// import { FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa';
// import Footer from '../Footer/Footer';
// import axios from "axios";
// import { useState } from "react";

// const Contact = () => {

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     organization: "",
//     subject: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await axios.post(
//         "https://api.info-sight.net/api/contact",
//         formData
//       );

//       if (res.data === "success") {
//         alert("Thank you for contacting us!");
//         setFormData({
//           name: "",
//           email: "",
//           organization: "",
//           subject: "",
//           message: "",
//         });
//       }
//     } catch (err) {
//       alert("Failed to submit form");
//     }
//   };


//   return (
//     <>
//       <Navbar />
//       <div className="contact-container">
//         <div className="contact-header">
//           <h1>Contact Us</h1>
//           <p>Thank you for your interest. Please fill out the form below to inquire about our work.</p>
//         </div>

//         <div className="contact-content">
//           {/* Left: Form */}
//           <div className="contact-form">
//             <form onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <label>Name</label>
//                 <input type="text"   name="name"  placeholder="Enter your name" value={formData.name} onChange={handleChange}/>
//               </div>

//               <div className="form-group">
//                 <label>E-mail</label>
//                 <input type="email"    name="email" placeholder="Enter your email"  value={formData.email} onChange={handleChange}/>
//               </div>

//               <div className="form-group">
//                 <label>Organization</label>
//                 <input type="text"   name="organization" placeholder="Your organization" value={formData.organization} onChange={handleChange}/>
//               </div>

//               <div className="form-group">
//                 <label>Subject</label>
//                 <input type="text"   name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange}/>
//               </div>

//               <div className="form-group">
//                 <label>Describe briefly</label>
//                 <textarea rows="5"   name="message"  placeholder="Write your message here..." value={formData.message} onChange={handleChange}></textarea>
//               </div>

//               <button type="submit" className="submit-btn">Let's Get Talking!</button>
//             </form>
//           </div>

//           {/* Right: Contact Details */}
//           {/* <div className="contact-details">
//             <div className="contact-block">
//               <h3>UAE</h3>
//               <p>1402, BB1 Tower,<br />Mazaya Business Avenue,<br />Jumeirah Lake Towers, Dubai, UAE.</p>
//               <p><strong>Phone:</strong> +971 4 4519958</p>
//               <p><strong>Mobile:</strong> +971 55 917 4244</p>
//               <p><strong>Email:</strong> info@info-sight.net</p>
//               <a href="https://www.google.com/maps?q=Infosight+Consultants" target="_blank" rel="noreferrer">Get directions</a>
//             </div>

//             <div className="contact-block">
//               <h3>Andhra Pradesh - India</h3>
//               <p>Infosight, NH16, Tadepalli,<br />Guntur District,<br />Andhra Pradesh - 520012, India</p>
//               <a href="https://www.google.com/maps?q=Infosight+Consultants" target="_blank" rel="noreferrer">Get directions</a>
//             </div>

//             <div className="contact-block">
//               <h3>Karnataka - India</h3>
//               <p>No.6, J S Complex , Attibele,<br />Sarjapur- Bangalore, Pin 562107. India</p>
//               <p><strong>Phone:</strong> +91 9900226979</p>
//               <a href="https://www.google.com/maps?q=Infosight+Consultants" target="_blank" rel="noreferrer">Get directions</a>
//             </div>
//           </div> */}
//           <div className="contact-details">
//   <div className="contact-block">
//     <h3>UAE</h3>
//     <p>
//       1402, BB1 Tower,<br />
//       Mazaya Business Avenue,<br />
//       Jumeirah Lake Towers, Dubai, UAE.
//     </p>
//     <p><strong>Phone:</strong> +971 505141005</p>
//     <p><strong>Email:</strong> suresh@info-sight.net</p>
//     <a
//       href="https://www.google.com/maps?q=Infosight+Consultants"
//       target="_blank"
//       rel="noreferrer"
//     >
//       Get directions
//     </a>
//   </div>

//   <div className="contact-block">
//     <h3>Andhra Pradesh - India</h3>
//     <p>
//       Infosight, NH16, Tadepalli,<br />
//       Guntur District,<br />
//       Andhra Pradesh - 520012, India
//     </p>
//     <p><strong>Phone:</strong> +91 90357 27034</p>
//     <p><strong>Email:</strong> vamsi@info-sight.net</p>
//     <a
//       href="https://www.google.com/maps?q=Infosight+Consultants"
//       target="_blank"
//       rel="noreferrer"
//     >
//       Get directions
//     </a>
//   </div>

//   <div className="contact-block">
//     <h3>Karnataka - India</h3>
//     <p>
//       No.6, J S Complex, Attibele,<br />
//       Sarjapur- Bangalore,<br />
//       Pin 562107, India
//     </p>
//     <p><strong>Phone:</strong> +91 90357 27034</p>
//     <p><strong>Email:</strong> vamsi@info-sight.net</p>
//     <a
//       href="https://www.google.com/maps?q=Infosight+Consultants"
//       target="_blank"
//       rel="noreferrer"
//     >
//       Get directions
//     </a>
//   </div>
// </div>

//         </div>

//         {/* Embedded Google Map */}
//         <div className="map-container">
//           <iframe
//             src="https://maps.google.com/maps?q=Infosight+Consultants&amp;iwloc=near&amp;output=embed"
//             frameBorder="0"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//             title="Company Location"
//             referrerPolicy="no-referrer-when-downgrade"
//           ></iframe>
//         </div>
//       </div>

//       {/* <footer className="footer">
//                   <div className="container footer-content">
//                     <p>© {new Date().getFullYear()} MyConsultants. All rights reserved.</p>
//                     <div className="socials">
//                       <FaFacebook />
//                       <FaLinkedin />
//                       <FaTwitter />
//                     </div>
//                   </div>
//                 </footer> */}

//                 <Footer/>
//     </>
//   );
// };

// export default Contact;


import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import axios from "axios";
import {
  FaBuilding,
  FaPhoneAlt,
  FaEnvelope,
  FaDirections,
  FaPaperPlane,
  FaMapMarkerAlt,
  FaUser,
  FaBuilding as FaCompany,
  FaTag,
  FaCheckCircle,
} from "react-icons/fa";

// Eye-Comfort Real Estate & Executive Palette
const theme = {
  bgApp: "#F8FAF9",
  bgCard: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  primary: "#0F172A", // Deep Slate Navy
  accent: "#0D9488", // Soft Emerald Teal
  accentLight: "#CCFBF1",
  accentHover: "#0F766E",
  textDark: "#1E293B",
  textMuted: "#64748B",
  border: "#E2E8F0",
  shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
  shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
  shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
};

// Global Responsive Injection
const inlineStyles = `
  .contact-page-root {
    background-color: ${theme.bgApp};
    color: ${theme.textDark};
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    min-height: 100vh;
  }

  /* Hero Section */
  .contact-hero-banner {
    background: linear-gradient(180deg, ${theme.primary} 0%, #1E293B 100%);
    padding: 60px 20px;
    text-align: center;
    color: #FFFFFF;
  }

  /* Split Layout */
  .contact-main-grid {
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
    gap: 36px;
    max-width: 1240px;
    margin: -40px auto 60px;
    padding: 0 20px;
    position: relative;
    z-index: 10;
  }

  /* Form Container */
  .contact-form-card {
    background-color: ${theme.bgCard};
    border-radius: 16px;
    padding: 36px;
    border: 1px solid ${theme.border};
    box-shadow: ${theme.shadowLg};
  }

  .form-row-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .form-field-wrapper {
    margin-bottom: 20px;
  }

  .form-field-label {
    display: block;
    font-size: 0.85rem;
    font-weight: 600;
    color: ${theme.textDark};
    margin-bottom: 6px;
  }

  .form-input-element {
    width: 100%;
    padding: 12px 14px;
    border-radius: 8px;
    border: 1px solid ${theme.border};
    background-color: ${theme.bgSubtle};
    color: ${theme.textDark};
    font-size: 0.925rem;
    outline: none;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    box-sizing: border-box;
  }

  .form-input-element:focus {
    border-color: ${theme.accent};
    background-color: #FFFFFF;
  }

  /* Office Cards Grid */
  .offices-list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .office-card-item {
    background-color: ${theme.bgCard};
    border-radius: 16px;
    padding: 24px;
    border: 1px solid ${theme.border};
    box-shadow: ${theme.shadowSm};
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  }

  .office-card-item:hover {
    transform: translateY(-4px);
    box-shadow: ${theme.shadowMd};
    border-color: ${theme.accent};
  }

  .direction-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${theme.accent};
    font-weight: 600;
    font-size: 0.85rem;
    text-decoration: none;
    margin-top: 12px;
    transition: color 0.2s ease;
  }

  .direction-link:hover {
    color: ${theme.accentHover};
  }

  @media (max-width: 992px) {
    .contact-main-grid {
      grid-template-columns: 1fr;
      margin-top: 20px;
    }
    .form-row-group {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 600px) {
    .contact-form-card {
      padding: 24px;
    }
  }
`;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const res = await axios.post(
        "https://api.info-sight.net/api/contact",
        formData
      );

      setIsSubmitting(false);

      if (res.data === "success" || res.status === 200) {
        alert("✅ Thank you for contacting us! Our team will get back to you shortly.");
        setFormData({
          name: "",
          email: "",
          organization: "",
          subject: "",
          message: "",
        });
      } else {
        alert("⚠️ Something went wrong. Please try again.");
      }
    } catch (err) {
      setIsSubmitting(false);
      console.error("Contact form error:", err);
      alert("❌ Failed to submit inquiry. Please try again later.");
    }
  };

  const officeLocations = [
    {
      region: "United Arab Emirates",
      address: "1402, BB1 Tower, Mazaya Business Avenue, Jumeirah Lake Towers, Dubai, UAE.",
      phone: "+971 505141005",
      email: "suresh@info-sight.net",
      mapUrl: "https://www.google.com/maps?q=Infosight+Consultants",
    },
    {
      region: "Andhra Pradesh - India",
      address: "Infosight, NH16, Tadepalli, Guntur District, Andhra Pradesh - 520012, India",
      phone: "+91 90357 27034",
      email: "vamsi@info-sight.net",
      mapUrl: "https://www.google.com/maps?q=Infosight+Consultants",
    },
    {
      region: "Karnataka - India",
      address: "No.6, J S Complex, Attibele, Sarjapur - Bangalore, Pin 562107, India",
      phone: "+91 90357 27034",
      email: "vamsi@info-sight.net",
      mapUrl: "https://www.google.com/maps?q=Infosight+Consultants",
    },
  ];

  return (
    <div className="contact-page-root">
      <style>{inlineStyles}</style>
      <Navbar />

      {/* Hero Header */}
      <section className="contact-hero-banner">
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          {/* <span
            style={{
              color: theme.accentLight,
              fontWeight: "600",
              fontSize: "0.85rem",
              letterSpacing: "1.2px",
              textTransform: "uppercase",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              padding: "6px 16px",
              borderRadius: "20px",
              display: "inline-block",
              // marginBottom: "12px",
            }}
          >
            Get In Touch
          </span> */}
          <h1 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "12px" }}>
            Contact Our Executive Team
          </h1>
          <p style={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "1rem", lineHeight: "1.6" }}>
            Inquire about our engineering consulting, smart building solutions, and global real estate developments.
          </p>
        </div>
      </section>

      {/* Main Form & Contact Split Grid */}
      <div className="contact-main-grid">
        {/* Left Box: Executive Inquiry Form */}
        <div className="contact-form-card">
          <h2 style={{ fontSize: "1.5rem", fontWeight: "700", color: theme.primary, marginBottom: "8px" }}>
            Send Us a Message
          </h2>
          <p style={{ color: theme.textMuted, fontSize: "0.9rem", marginBottom: "28px" }}>
            Fill out the information below and a consultant will connect with you.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-row-group">
              <div className="form-field-wrapper">
                <label className="form-field-label">Your Name *</label>
                <input
                  type="text"
                  name="name"
                  placeholder="e.g. John Doe"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input-element"
                />
              </div>

              <div className="form-field-wrapper">
                <label className="form-field-label">Email Address *</label>
                <input
                  type="email"
                  name="email"
                  placeholder="e.g. john@company.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input-element"
                />
              </div>
            </div>

            <div className="form-row-group">
              <div className="form-field-wrapper">
                <label className="form-field-label">Organization / Company</label>
                <input
                  type="text"
                  name="organization"
                  placeholder="Company Name"
                  value={formData.organization}
                  onChange={handleChange}
                  className="form-input-element"
                />
              </div>

              <div className="form-field-wrapper">
                <label className="form-field-label">Inquiry Subject *</label>
                <input
                  type="text"
                  name="subject"
                  placeholder="e.g. IBMS Project Consultation"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="form-input-element"
                />
              </div>
            </div>

            <div className="form-field-wrapper">
              <label className="form-field-label">Project Details / Message *</label>
              <textarea
                rows="5"
                name="message"
                placeholder="Describe your requirement briefly..."
                value={formData.message}
                onChange={handleChange}
                required
                className="form-input-element"
                style={{ resize: "vertical" }}
              ></textarea>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                width: "100%",
                backgroundColor: theme.accent,
                color: "#FFFFFF",
                border: "none",
                padding: "14px",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "0.95rem",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                opacity: isSubmitting ? 0.7 : 1,
                transition: "backgroundColor 0.2s ease",
              }}
            >
              {isSubmitting ? "Sending Inquiry..." : "Submit Inquiry"} <FaPaperPlane size={14} />
            </button>
          </form>
        </div>

        {/* Right Box: Regional Office Cards */}
        <div className="offices-list-wrapper">
          <h2 style={{ fontSize: "1.25rem", fontWeight: "700", color: theme.primary, marginBottom: "8px" }}>
            Global Offices & Hubs
          </h2>

          {officeLocations.map((office, idx) => (
            <div key={idx} className="office-card-item">
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px" }}>
                <div style={{ backgroundColor: theme.accentLight, padding: "8px 10px", borderRadius: "8px", color: theme.accent }}>
                  <FaBuilding size={16} />
                </div>
                <h3 style={{ fontSize: "1.1rem", fontWeight: "700", color: theme.primary, margin: 0 }}>
                  {office.region}
                </h3>
              </div>

              <p style={{ color: theme.textMuted, fontSize: "0.9rem", lineHeight: "1.5", marginBottom: "14px" }}>
                {office.address}
              </p>

              <div style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "0.875rem" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", color: theme.textDark }}>
                  <FaPhoneAlt size={12} color={theme.accent} />
                  <span>{office.phone}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", color: theme.textDark }}>
                  <FaEnvelope size={12} color={theme.accent} />
                  <span>{office.email}</span>
                </div>
              </div>

              <a
                href={office.mapUrl}
                target="_blank"
                rel="noreferrer"
                className="direction-link"
              >
                <FaDirections /> Get Directions on Google Maps
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Embedded Google Map Section */}
      <section style={{ maxWidth: "1240px", margin: "0 auto 60px", padding: "0 20px" }}>
        <div style={{ borderRadius: "16px", overflow: "hidden", border: `1px solid ${theme.border}`, boxShadow: theme.shadowSm }}>
          <iframe
            src="https://maps.google.com/maps?q=Infosight+Consultants&amp;iwloc=near&amp;output=embed"
            width="100%"
            height="380"
            style={{ border: 0, display: "block" }}
            allowFullScreen=""
            loading="lazy"
            title="Infosight Location Map"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;